import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "src/store";
import { makeStyles } from "tss-react/mui";

import { selectPaneEditEnabled, setPaneEditEnabled } from "@devices/store";
import { Box, useTheme } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "@shared/CustomButton";

type Props = {
    loading: boolean | undefined;
    pristine?: boolean;
};

const useStyles = makeStyles()(() => ({
    stickyFooter: {
        position: "sticky",
        right: "1%",
        bottom: "5%",
        float: "right",
        display: "flex",
    },
}));

export const EditPrimaryButtons = ({ loading, pristine }: Props) => {
    const { t } = useTranslation(["common"]);
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();
    const editEnabled = useSelector(selectPaneEditEnabled);

    if (!editEnabled) {
        return null;
    }

    return (
        <Box className={classes.stickyFooter}>
            <SecondaryButton onClick={() => dispatch(setPaneEditEnabled(false))} loading={loading} disabled={loading}>
                {t("common:button.cancel")}
            </SecondaryButton>
            <PrimaryButton
                type="submit"
                loading={loading}
                disabled={loading || pristine}
                style={{ marginLeft: theme.spacing(1) }}
            >
                {t("common:button.save")}
            </PrimaryButton>
        </Box>
    );
};
